import type { AgentMessage } from '@multiplayer-app/ai-agent-types'
import { MessageRole } from '@multiplayer-app/ai-agent-types'
import { MessageContent } from './MessageContent'
import { MessageActions } from './MessageActions'
import { MessageAttachments } from '@/components/Attachments'

interface MessageBubbleProps {
  message: AgentMessage
}

export const MessageBubble = ({ message }: MessageBubbleProps) => {
  const isUser = message.role === MessageRole.User
  const isError = message.role === MessageRole.Error
  const isReasoning = message.role === MessageRole.Reasoning
  const hasContent = !!message.content
  const hasAttachments = (message.attachments?.length ?? 0) > 0

  return (
    <div
      className={`mp-agent-message-wrapper ${
        isUser ? 'mp-agent-message-user' : isError ? 'mp-agent-message-error' : 'mp-agent-message-assistant'
      }`}
    >
      <div className='mp-agent-message-content-wrapper'>
        <div
          className={`mp-agent-message-bubble ${
            isUser
              ? 'mp-agent-message-bubble-user'
              : isError
              ? 'mp-agent-message-bubble-error'
              : 'mp-agent-message-bubble-assistant'
          }`}
        >
          <div className='mp-agent-message-text'>
            {hasAttachments && <MessageAttachments attachments={message.attachments ?? []} />}
            {hasContent && <MessageContent content={message.content} role={message.role} />}
          </div>
          {!isUser && hasContent && <MessageActions text={message.content} isReasoning={isReasoning} />}
        </div>
      </div>
    </div>
  )
}
